import { CityPersonLocaleRO } from '@routellers/types/dist/city-person/city-person-locale.ro';
import { PersonFactKindEnum } from '@routellers/types/dist/city-person/enum/person-fact-kind.enum';
import { PersonLocaleStatusEnum } from '@routellers/types/dist/city-person/enum/person-locale-status.enum';
import { PersonLocaleFact } from '@routellers/types/dist/city-person/person-locale-fact';
import { Languages } from '@routellers/types/dist/shared/enum/languages.enum';

export type PersonLocaleDraft = {
    name: string;
    knownFor: string;
    description: string;
    facts: PersonLocaleFact[];
    status: PersonLocaleStatusEnum;
};

export const emptyFact = (): PersonLocaleFact => ({
    id: `fact_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    kind: PersonFactKindEnum.BIO,
    title: '',
    body: '',
});

export const emptyPersonLocaleDraft = (fallbackName = ''): PersonLocaleDraft => ({
    name: fallbackName,
    knownFor: '',
    description: '',
    facts: [],
    status: PersonLocaleStatusEnum.EMPTY,
});

export const findPersonLocale = (locales: CityPersonLocaleRO[] | undefined, language: Languages) =>
    locales?.find((l) => l.language === language);

export const personLocaleToDraft = (
    locale: CityPersonLocaleRO | undefined,
    fallbackName = '',
): PersonLocaleDraft => ({
    name: locale?.name || fallbackName,
    knownFor: locale?.knownFor || '',
    description: locale?.description || '',
    facts: locale?.facts?.length ? locale.facts.map((f) => ({ ...f })) : [],
    status: locale?.status || PersonLocaleStatusEnum.EMPTY,
});

export const hasPersonLocaleContent = (draft: PersonLocaleDraft) =>
    !!draft.name.trim() ||
    !!draft.knownFor.trim() ||
    !!draft.description.trim() ||
    draft.facts.some((f) => f.body?.trim() || f.title?.trim());
